module.exports = __webpack_public_path__ + "img/districts.8e2bcb08.svg";